import { ReactNode, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../hooks/reduxHooks';
import { fetchCurrentUser, logout } from '../store/slices/authSlice';

interface PrivateRouteProps {
  children: ReactNode;
}

const PrivateRoute = ({ children }: PrivateRouteProps): React.ReactElement => {
  const dispatch = useAppDispatch();
  const { token, user, loading: authLoading } = useAppSelector((state) => state.auth);
  const [isInitialCheck, setIsInitialCheck] = useState(true);

  useEffect(() => {
    if (token && !user) {
      dispatch(fetchCurrentUser())
        .unwrap()
        .catch(() => {
          // fetchCurrentUser.rejected'da zaten logout yapılıyor.
        })
        .finally(() => {
          setIsInitialCheck(false);
        });
    } else {
      setIsInitialCheck(false);
    }
  }, [token, user, dispatch]);

  if (isInitialCheck || authLoading) {
    return (
      <div className="flex justify-center items-center h-screen bg-gray-100">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-blue-600"></div>
        <p className="ml-4 text-lg text-gray-700">Yükleniyor...</p>
      </div>
    );
  }

  if (!token) {
    return <Navigate to="/login" />;
  }

  return <>{children}</>;
};

export default PrivateRoute; 